module.exports = __webpack_public_path__ + "static/media/webvision6.576fcdd7.png";